import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import SEO from '@/components/SEO';

const GuidesPage = () => {
  return (
    <>
      <SEO 
        title="CauseConnect Guides - Resources for Nonprofits" 
        description="Explore our comprehensive guides and resources to help your nonprofit leverage technology and maximize impact."
      />
      <div className="min-h-screen bg-gradient-to-b from-[#F2FCE2] to-white">
        {/* Hero Section */}
        <div className="relative overflow-hidden bg-[#2D7D46] text-white py-20">
          <div className="absolute inset-0 bg-[url('/images/hero-pattern.svg')] opacity-10" />
          <div className="container mx-auto px-4 relative">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                CauseConnect Guides
              </h1>
              <p className="text-xl md:text-2xl text-gray-100 mb-1">
                In-depth resources to help your nonprofit thrive in the digital age
              </p>
            </div>
          </div>
        </div>

        {/* Guides List Section */}
        <div className="container mx-auto px-4 py-16">
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {/* Chatbot Guide Card */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <img 
                src="/images/chatbot-guide-hero.jpg" 
                alt="Chatbot Guide" 
                className="w-full h-42 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-3">
                  The Ultimate Guide to Chatbots for Nonprofits
                </h3>
                <p className="text-gray-600 mb-4">
                  Learn how chatbots can transform your nonprofit's engagement, streamline operations, and maximize impact.
                </p>
                <Link to="/guides/chatbots-for-nonprofits">
                  <Button className="w-full">Read Guide</Button>
                </Link>
              </div>
            </div>

            {/* AI Content Tools Guide Card */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <img 
                src="/images/ai-content-tools.jpg" 
                alt="AI Content Tools Guide" 
                className="w-full h-37 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-3">
                  Top AI Content Creation Tools for Nonprofits
                </h3>
                <p className="text-gray-600 mb-4">
                  Discover how AI can help your nonprofit create compelling content, from social media to impact reports.
                </p>
                <Link to="/guides/ai-content-tools">
                  <Button className="w-full">Read Guide</Button>
                </Link>
              </div>
            </div>

            {/* AI Tools for Nonprofits Guide Card */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <img 
                src="/images/ai-nonprofit-tools.jpg" 
                alt="AI Tools for Nonprofits Guide" 
                className="w-full h-43 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-3">
                  AI Tools for Nonprofits: Grant Writing & More
                </h3>
                <p className="text-gray-600 mb-4">
                  Explore how AI can revolutionize your grant writing, impact reporting, and elevator pitches.
                </p>
                <Link to="/guides/ai-tools-for-nonprofits">
                  <Button className="w-full">Read Guide</Button>
                </Link>
              </div>
            </div>

            {/* Disaster Response Guide Card */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <img 
                src="/images/guides/disaster-response.jpg" 
                alt="Disaster Response Guide" 
                className="w-full h-43 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-3">
                  Disaster Response Guide
                </h3>
                <p className="text-gray-600 mb-4">
                  Step-by-step playbooks and checklists for nonprofit and corporate disaster response.
                </p>
                <Link to="/guides/disaster-response-guide">
                  <Button className="w-full">Read Guide</Button>
                </Link>
              </div>
            </div>

            {/* NGO Readiness Checklist Guide Card */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <img 
                src="/images/guides/ngo-readiness.jpg" 
                alt="NGO Readiness Checklist Guide" 
                className="w-full h-43 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-3">
                  NPO Readiness Checklist
                </h3>
                <p className="text-gray-600 mb-4">
                  A comprehensive onboarding checklist for nonprofits partnering with corporates via CauseConnect. Covers compliance, documentation, impact, and red flags for India and U.S.-based NPOs.
                </p>
                <Link to="/guides/ngo-readiness-checklist">
                  <Button className="w-full">Read Guide</Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GuidesPage;
